import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_outbound_shipment_summary_report_auto_emailService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, GrossWeight?: number, NetWeight?: number, Shipment?: { ShippedDate?: string }, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string } } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { projectId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, GrossWeight?: number, NetWeight?: number, Shipment?: { ShippedDate?: string }, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string } } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { projectId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, GrossWeight?: number, NetWeight?: number, Shipment?: { ShippedDate?: string }, OrderLine?: { OrderId?: number, Order?: { LookupCode?: string, OwnerReference?: string }, Material?: { Description?: string, LookupCode?: string }, Lot?: { LookupCode?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId?: number    }) {
      return false;
    }
}
